<template>
  <div id="app" class="min-h-screen h-screen overflow-hidden font-cairo">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body { font-family: var(--ods-font); transition: background-color 0.2s, color 0.2s; font-weight: 500; }
#app { background: var(--ods-bg); color: var(--ods-ink); }
.order-card { transition: box-shadow .15s, border-color .15s; cursor: pointer; display: flex; flex-direction: column; border-radius: var(--ods-radius); overflow: hidden; box-shadow: var(--ods-shadow-sm); background: var(--ods-surface); color: var(--ods-ink); border: 1px solid var(--ods-line); }
.order-card:hover { box-shadow: var(--ods-shadow); border-color: var(--ods-line-2); }
.button-prepare { background: var(--ods-prep); color: #fff; font-weight: 700; border-radius: var(--ods-radius); }
.button-complete { background: var(--ods-ok); color: #fff; font-weight: 700; border-radius: var(--ods-radius); }
</style>